import {
  isNotifyFrequency,
  NOTIFY_FREQUENCY,
  NotifyFrequency,
} from "@/app/(discover)/jobs/[stateName]/(state-jobs)/components/alerts/notify-frequency";
import { GetJobAlertsResponse } from "@/hooks/data/use-job-alerts";

type JobAlerts = GetJobAlertsResponse["data"];

export type JobAlertsFormValues = {
  notifyFrequency: NotifyFrequency;
  savedSchoolsEnabled: boolean;
  preferencesEnabled: boolean;
  savedSearchesEnabled: boolean;
};

export const JOB_ALERTS_FORM_DEFAULTS: JobAlertsFormValues = {
  notifyFrequency: NOTIFY_FREQUENCY.off,
  savedSchoolsEnabled: false,
  preferencesEnabled: false,
  savedSearchesEnabled: false,
};

export const toJobAlertsFormValues = (
  alerts: JobAlerts | null,
): JobAlertsFormValues => {
  if (!alerts || !isNotifyFrequency(alerts.notifyFrequency)) {
    return JOB_ALERTS_FORM_DEFAULTS;
  }
  return {
    notifyFrequency: alerts.notifyFrequency,
    savedSchoolsEnabled: alerts.savedSchoolsEnabled,
    preferencesEnabled: alerts.preferencesEnabled,
    savedSearchesEnabled: alerts.savedSearchesEnabled,
  };
};
